exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.col-43[data-v-15225026] {\n  color: #424343;\n}\n.col_E2[data-v-15225026] {\n  color: #4A90E2;\n}\n.listhg[data-v-15225026] {\n  height: 2.25rem;\n}", ""]);

// exports
